import { ChangeDetectionStrategy, Component, input, output, signal, ViewEncapsulation } from '@angular/core';
import { Message } from 'primeng/message';
import { AppButton } from '@uikit/button/button.component';

import { PromotionModel } from '../../models';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [Message, AppButton]
})
export class BannerComponent {
  public promotions = input<PromotionModel[]>([]);
  public ctaClicked = output<void>();
  public closedIndices = signal(new Set<number>());

  public ctaButtonClick() {
    this.ctaClicked.emit();
  }

  public closeBanner(index: number) {
    this.closedIndices.update(set => new Set(set).add(index));
  }
}
